'use client';

import React from 'react';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import { ArrowLeft } from '@/blocks/components/Icons';
import { LinkI18n } from '@/i18n/routing';
import buttons from '@/styles/button.module.scss';

import styles from './styles.module.scss';

export function BackButton(props: { text?: string; href: string }) {
  const tr = useTranslations();
  const { text = tr.rich('pages.strategyPage.sections.hero.backButton') } = props;
  return (
    <LinkI18n
      href={props.href}
      className={classNames(buttons.btn, buttons.btnLink, buttons.btnM, styles.backButton)}
    >
      <ArrowLeft />
      {text}
    </LinkI18n>
  );
}
